import { render, staticRenderFns } from "./MemberLevelComponent.vue?vue&type=template&id=927b6084&"
import script from "./MemberLevelComponent.vue?vue&type=script&lang=js&"
export * from "./MemberLevelComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports